var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2774 0.165894C4.92956 0.165894 4.64758 0.44788 4.64758 0.795721V1.42555H1.07856C0.730717 1.42555 0.44873 1.70753 0.44873 2.05537C0.44873 2.40322 0.730717 2.6852 1.07856 2.6852H12.8353C13.1832 2.6852 13.4652 2.40322 13.4652 2.05537C13.4652 1.70753 13.1832 1.42555 12.8353 1.42555H9.26631V0.795721C9.26631 0.44788 8.98432 0.165894 8.63648 0.165894H5.2774Z",
    fill: "#B73F21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27729 7.21997C5.62512 7.21997 5.90712 7.50197 5.90712 7.8498V13.7282C5.90712 14.076 5.62512 14.358 5.27729 14.358C4.92945 14.358 4.64746 14.076 4.64746 13.7282V7.8498C4.64746 7.50197 4.92945 7.21997 5.27729 7.21997Z",
    fill: "#B73F21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26625 7.8498C9.26625 7.50197 8.98425 7.21997 8.63642 7.21997C8.28859 7.21997 8.00659 7.50197 8.00659 7.8498V13.7282C8.00659 14.076 8.28859 14.358 8.63642 14.358C8.98425 14.358 9.26625 14.076 9.26625 13.7282V7.8498Z",
    fill: "#B73F21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91123 4.92502C1.94668 4.60605 2.21629 4.36475 2.53721 4.36475H11.3769C11.6978 4.36475 11.9675 4.60605 12.0029 4.92502L12.1709 6.43773C12.4756 9.17982 12.4756 11.9473 12.1709 14.6894L12.1544 14.8384C12.0335 15.9268 11.1898 16.7948 10.1053 16.9466C8.01668 17.239 5.89743 17.239 3.80883 16.9466C2.72423 16.7948 1.88065 15.9268 1.75971 14.8384L1.74316 14.6894C1.43848 11.9473 1.43848 9.17982 1.74316 6.43773L1.91123 4.92502ZM3.10094 5.6244L2.99511 6.57684C2.7007 9.22651 2.7007 11.9007 2.99511 14.5503L3.01165 14.6992C3.06902 15.2154 3.46909 15.6271 3.98347 15.6991C5.95622 15.9752 7.95789 15.9752 9.9306 15.6991C10.445 15.6271 10.8451 15.2154 10.9025 14.6992L10.919 14.5503C11.2134 11.9007 11.2134 9.22651 10.919 6.57684L10.8132 5.6244H3.10094Z",
    fill: "#B73F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.d4b6644d9b8b02f9af263683d3e6013c.svg";
export { ForwardRef as ReactComponent };